import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUser } from '../../../../store/slices/authSlice';
import api from '../../../../api/axios';
import { showSuccess, showError } from '../../../../utils/toast';
import { getIndStates, getCountryCodes } from '../../../../utils/common';
import useAuth from '../../../../hooks/useAuth';
import { useLoading } from '../../../../components/LoadingProvider';
import { getPublicImgUrl } from '../../../../utils/common';

export default function ClinicProfileEdit() {
    document.title = 'Varosa - Clinic Profile';
    const fetchedRef = useRef(false);
    const { user, userRole } = useAuth({ redirectPath: '/login', allowedRoles: ['clinic'] });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const indStates = getIndStates();
    const countryCodes = getCountryCodes();
    const { setIsLoading } = useLoading();

    const [previewUrl, setPreviewUrl] = useState(getPublicImgUrl() + '/simg.jpg');
    const fileInputRef = useRef(null);
    const errorDivRef = useRef(null);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [passwordBtnDisabled, setPasswordBtnDisabled] = useState(false);
    const [clinicStatus, setClinicStatus] = useState(null);
    const [prefixOfName, setPrefixOfName] = useState([ 'Dr.', 'Prof.', 'Mr.', 'Mrs.', 'Ms.' ]);
    const [errors, setErrors] = useState({
        profile_pic: '',
        clinic_name: '',
        owner_name: '',
        owner_name_prefix: '',
        registration_number: '',
        contact_number_code: '',
        contact_number: '',
        address_line1: '',
        address_line2: '',
        address_district: '',
        address_state: '',
        address_country: '',
        address_pincode: '',
        email: '',
        bank_name: '',
        bank_account_number: '',
        bank_ifsc_code: '',
        pan_card_number: '',

        user_name: '',
        user_phone_code: '',
        user_phone_number: '',
        user_email: ''
    });
    const [passwordErrors, setPasswordErrors] = useState({
        old_password: '',
        new_password: '',
        confirm_password: ''
    });

    const [formData, setFormData] = useState({
        profile_pic: '',
        clinic_name: '',
        owner_name: '',
        owner_name_prefix: '',
        registration_number: '',
        contact_number_code: '',
        contact_number: '',
        address_line1: '',
        address_line2: '',
        address_district: '',
        address_state: '',
        address_country: 'India',
        address_pincode: '',
        email: '',
        bank_name: '',
        bank_account_number: '',
        bank_ifsc_code: '',
        pan_card_number: '',

        user_name: user?.name || '',
        user_phone_code: user?.phone_code || '',
        user_phone_number: user?.phone_number || '',
        user_email: user?.email || ''
    });
    const [passwordFormData, setPasswordFormData] = useState({
        old_password: '',
        new_password: '',
        confirm_password: ''
    });

    const validateForm = () => {
        let all_good = true;
        let error = {
            profile_pic: '',
            clinic_name: '',
            owner_name: '',
            owner_name_prefix: '',
            registration_number: '',
            contact_number_code: '',
            contact_number: '',
            address_line1: '',
            address_line2: '',
            address_district: '',
            address_state: '',
            address_country: '',
            address_pincode: '',
            email: '',
            bank_name: '',
            bank_account_number: '',
            bank_ifsc_code: '',
            pan_card_number: '',
            user_name: '',
            user_phone_code: '',
            user_phone_number: '',
            user_email: '',
        };

        if(formData.clinic_name.trim() === ''){
            error.clinic_name = 'Please enter your clinic name.';
            all_good = false;
        }
        if(formData.owner_name.trim() === ''){
            error.owner_name = 'Please enter your owner name.';
            all_good = false;
        }
        if(formData.owner_name_prefix.trim() === ''){
            error.owner_name_prefix = 'Please select a valid prefix.';
            all_good = false;
        }
        // if(formData.registration_number.trim() === ''){
        //     error.registration_number = 'Please enter your registration number.';
        //     all_good = false;
        // }
        if(formData.contact_number_code.trim() === ''){
            error.contact_number_code = 'Please select a valid country code.';
            all_good = false;
        }
        if(formData.contact_number.trim() === ''){
            error.contact_number = 'Please enter your contact number.';
            all_good = false;
        }
        if(formData.email.trim() !== '' && !/^\S+@\S+\.\S+$/.test(formData.email.trim())){
            error.email = 'Please enter a valid email.';
            all_good = false;
        }
        if(formData.address_line1.trim() === ''){
            error.address_line1 = 'Please enter your address.';
            all_good = false;
        }
        // if(formData.address_line2.trim() === ''){
        //     error.address_line2 = 'Please enter your address2.';
        //     all_good = false;
        // }
        if(formData.address_district.trim() === ''){
            error.address_district = 'Please enter your district.';
            all_good = false;
        }
        if(formData.address_state.trim() === ''){
            error.address_state = 'Please enter your state.';
            all_good = false;
        }
        if(formData.address_pincode.trim() === ''){
            error.address_pincode = 'Please enter your pincode.';
            all_good = false;
        }
        if(formData.bank_name.trim() === ''){
            error.bank_name = 'Please enter your bank name.';
            all_good = false;
        }
        if(formData.bank_account_number.trim() === ''){
            error.bank_account_number = 'Please enter your bank account number.';
            all_good = false;
        }
        if(formData.bank_ifsc_code.trim() === ''){
            error.bank_ifsc_code = 'Please enter your bank IFSC code.';
            all_good = false;
        }
        if(formData.pan_card_number.trim() === ''){
            error.pan_card_number = 'Please enter your PAN card number.';
            all_good = false;
        }
        if(formData.user_name.trim() === ''){
            error.user_name = 'Please enter your user name.';
            all_good = false;
        }
        if(formData.user_phone_code.trim() === ''){
            error.user_phone_code = 'Please select a valid country code.';
            all_good = false;
        }
        if(formData.user_phone_number.trim() === ''){
            error.user_phone_number = 'Please enter your phone number.';
            all_good = false;
        }
        if(formData.user_email.trim() === '' ){
            error.user_email = 'Please enter your email.';
            all_good = false;
        }
        if(formData.user_email.trim() !== '' && !/^\S+@\S+\.\S+$/.test(formData.user_email.trim())){
            error.user_email = 'Please enter a valid email.';
            all_good = false;
        }

        setErrors(error);
        return all_good;
    };

    const validatePasswordForm = () => {
        let all_good = true;
        let error = {
            old_password: '',
            new_password: '',
            confirm_password: ''
        };

        if (passwordFormData.old_password.trim() === '') {
            error.old_password = 'Please enter your old password.';
            all_good = false;
        }
        if (passwordFormData.new_password.trim() === '') {
            error.new_password = 'Please enter your new password.';
            all_good = false;
        } else if (passwordFormData.new_password.length < 8) {
            error.new_password = 'New password must be at least 8 characters.';
            all_good = false;
        }
        if (passwordFormData.confirm_password.trim() === '') {
            error.confirm_password = 'Please confirm your new password.';
            all_good = false;
        } else if (passwordFormData.new_password !== passwordFormData.confirm_password) {
            error.confirm_password = 'New password and confirm password do not match.';
            all_good = false;
        }
        if (
            passwordFormData.old_password &&
            passwordFormData.new_password &&
            passwordFormData.old_password === passwordFormData.new_password
        ) {
            error.new_password = 'New password must be different from old password.';
            all_good = false;
        }

        setPasswordErrors(error);
        return all_good;
    };

    const fetchClinicData = useCallback(async () => {
        setBtnDisabled(true);
        try {
            const response = await api.get('/'+userRole+'/details');
            if (response?.data?.result === 'success') {
                let clinic_details = response.data.data.clinic_details;
                let user_details = response.data.data.user_details;
                setFormData({
                    profile_pic: clinic_details?.profile_picture || null,
                    clinic_name: clinic_details?.clinic_name || '',
                    owner_name: clinic_details?.owner_name || '',
                    owner_name_prefix: clinic_details?.owner_name_prefix || '',
                    registration_number: clinic_details?.registration_number || '',
                    contact_number_code: clinic_details?.contact_number_code || '',
                    contact_number: clinic_details?.contact_number || '',
                    address_line1: clinic_details?.address_line1 || '',
                    address_line2: clinic_details?.address_line2 || '',
                    address_district: clinic_details?.address_district || '',
                    address_state: clinic_details?.address_state || '',
                    address_country: clinic_details?.address_country || 'India',
                    address_pincode: clinic_details?.address_pincode || '',
                    email: clinic_details?.email || '',
                    bank_name: clinic_details?.bank_name || '',
                    bank_account_number: clinic_details?.bank_account_number || '',
                    bank_ifsc_code: clinic_details?.bank_ifsc_code || '',
                    pan_card_number: clinic_details?.pan_card_number || '',

                    user_name: user_details?.name || '',
                    user_phone_code: user_details?.phone_code || '',
                    user_phone_number: user_details?.phone_number || '',
                    user_email: user_details?.email || ''
                });
                setClinicStatus(clinic_details?.status);
                if(clinic_details?.profile_picture){
                    setPreviewUrl(clinic_details?.profile_picture || null);
                }
                dispatch(setUser({
                    name: user_details?.name || '',
                    email: user_details?.email || '',
                    phone_code: user_details?.phone_code || '',
                    phone_number: user_details?.phone_number || '',
                    profile_pic: clinic_details?.profile_picture || '',
                }));
            }else if (response?.data?.result === 'failed') {
                showError(response?.data?.message);
                if(response?.data?.errors){
                    response?.data?.errors.forEach((item, index, arr) => {
                        showError(item);
                    });
                }
            } else {
                showError('Something went wrong! Please try again later.');
            }
        } catch (error) {
            showError('Something went wrong! Please try again later.');
            if (error.response?.status === 401) {
                navigate('/login');
            }
        } finally {
            setBtnDisabled(false);
        }
    }, []);
    useEffect(() => {
        if (fetchedRef.current) return;
        fetchedRef.current = true;
        fetchClinicData();
    }, [fetchClinicData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setFormData(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handlePasswordInputChange = (e) => {
        const { name, value } = e.target;
        setPasswordFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setPasswordErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };

    const handleProfilePicUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setErrors(prev => ({
            ...prev,
            profile_pic: ''
        }));

        // Validate file type
        const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        if (!validTypes.includes(file.type)) {
            setErrors(prev => ({
                ...prev,
                profile_pic: 'Please select a valid image file (JPEG, JPG, or PNG).'
            }));
            return;
        }

        // Validate file size (max 2MB)
        if (file.size > 2 * 1024 * 1024) {
            setErrors(prev => ({
                ...prev,
                profile_pic: 'File size exceeds 2MB. Please choose a smaller file.'
            }));
            return;
        }

        setFormData(prev => ({
            ...prev,
            profile_pic: file,
        }));

        // Create preview
        const reader = new FileReader();
        reader.onload = () => {
            setPreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleResetProfilePicUpload = () => {
        setPreviewUrl(getPublicImgUrl() + '/simg.jpg');
        setFormData(prev => ({
            ...prev,
            profile_pic: '',
        }));
        setErrors(prev => ({
            ...prev,
            profile_pic: ''
        }));
        fileInputRef.current.value = '';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if(!validateForm()){
                errorDivRef.current.scrollIntoView({ behavior: 'smooth' });
                return; 
            }
            const postData = new FormData();
            postData.append('clinic_name', formData.clinic_name || '');
            postData.append('owner_name', formData.owner_name || '');
            postData.append('owner_name_prefix', formData.owner_name_prefix || '');
            postData.append('registration_number', formData.registration_number || '');
            postData.append('contact_number_code', formData.contact_number_code || '');
            postData.append('contact_number', formData.contact_number || '');
            postData.append('address_line1', formData.address_line1 || '');
            postData.append('address_line2', formData.address_line2 || '');
            postData.append('address_district', formData.address_district || '');
            postData.append('address_state', formData.address_state || '');
            postData.append('address_country', formData.address_country || '');
            postData.append('address_pincode', formData.address_pincode || '');
            postData.append('email', formData.email || '');
            postData.append('bank_name', formData.bank_name || '');
            postData.append('bank_account_number', formData.bank_account_number || '');
            postData.append('bank_ifsc_code', formData.bank_ifsc_code || '');
            postData.append('pan_card_number', formData.pan_card_number || '');
            postData.append('user_name', formData.user_name || '');
            postData.append('user_phone_code', formData.user_phone_code || '');
            postData.append('user_phone_number', formData.user_phone_number || '');
            postData.append('user_email', formData.user_email || '');
            if (formData.profile_pic) {
                postData.append('profile_picture', formData.profile_pic);
            }

            setBtnDisabled(true);
            setIsLoading(true);
            const response = await api.post('/'+userRole+'/details', postData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response?.data?.result === 'success') {
                showSuccess(response.data.message);
                fetchClinicData();
            }else if (response?.data?.result === 'failed') {
                showError(response?.data?.message);
                if(response?.data?.errors){
                    response?.data?.errors.forEach((item, index, arr) => {
                        showError(item);
                    });
                }
            } else {
                showError('Something went wrong! Please try again later.');
            }
        } catch (error) {
            showError(error.response?.data?.message || 'Error updating profile');
        } finally {
            setBtnDisabled(false);
            setIsLoading(false);
        }
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!validatePasswordForm()) {
                return;
            }

            setPasswordBtnDisabled(true);
            setIsLoading(true);
            const response = await api.post('/'+userRole+'/password', {
                old_password: passwordFormData.old_password,
                new_password: passwordFormData.new_password,
                new_password_confirmation: passwordFormData.confirm_password
            });

            if (response?.data?.result === 'success') {
                showSuccess(response.data.message);
                setPasswordFormData({
                    old_password: '',
                    new_password: '',
                    confirm_password: ''
                });
                setPasswordErrors({
                    old_password: '',
                    new_password: '',
                    confirm_password: ''
                });
            } else if (response?.data?.result === 'failed') {
                showError(response?.data?.message);
                if (response?.data?.errors) {
                    response?.data?.errors.forEach((item) => {
                        showError(item);
                    });
                }
            } else {
                showError('Something went wrong! Please try again later.');
            }
        } catch (error) {
            showError(error.response?.data?.message || 'Error updating password');
        } finally {
            setPasswordBtnDisabled(false);
            setIsLoading(false);
        }
    };

    return (
        <div className="container py-5 login-container">
            <div className="row g-3">
                <div className="col-9">
                    <h2 className="mb-4">Clinic's Profile</h2>
                </div>
                <div className="col-3 text-end">
                    <button onClick={() => window.history.go(-1)} className="btn btn-primary">Back</button>
                </div>
            </div>
            <form onSubmit={handleSubmit} className="needs-validation" ref={errorDivRef}>
                <div className="row g-3">
                    <div className="col-md-12">
                        <div className="form-group text-center">
                            <div className="img-preview-container mb-3">
                                {previewUrl && <img id="imagePreview" src={previewUrl} className="img-thumbnail" width={300} alt="Profile" />}
                            </div>
                            <input type="file" id="profilePicInput" accept="image/*" className="d-none" ref={fileInputRef} onChange={handleProfilePicUpload} />
                            <button type="button" className="btn btn-outline-primary mx-2 mt-2" onClick={() => fileInputRef.current.click()}>
                                <i className="fas fa-upload mr-2"></i> Upload Profile Picture
                            </button>
                            <button type="button" className="btn btn-outline-danger mx-2 mt-2" onClick={handleResetProfilePicUpload}>
                                <i className="fas fa-times mr-2"></i> Reset Profile Picture
                            </button>
                            <div className="text-muted mt-2">
                                <small>JPEG, JPG, or PNG. Max size 2MB.</small>
                            </div>
                            {errors.profile_pic && <div className="invalid-feedback d-block">{errors.profile_pic}</div>}
                        </div>
                        {clinicStatus === 'pending' && <div className="alert alert-warning alert-dismissible fade show mt-4" role="alert">
                            <h4 className="alert-heading">Almost Done!</h4>
                            <hr />
                            <p className="mb-0">Your clinic status is in pending.</p>
                        </div>}
                        {clinicStatus === 'active' && <div className="alert alert-success alert-dismissible fade show mt-4" role="alert">
                            <h4 className="alert-heading">Well Done!</h4>
                            <hr />
                            <p className="mb-0">Your clinic status is active now.</p>
                        </div>}
                    </div>
                    {/* Basic Information */}
                    <div className="col-md-6">
                        <label className="form-label">Name of Clinic</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="clinic_name"
                            value={formData.clinic_name}
                            onChange={handleInputChange}
                        />
                        {errors.clinic_name && <div className="invalid-feedback d-block">Please enter a valid name of clinic.</div>}
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Name of Owner</label>
                        <div className="input-group mb-3">
                            <select 
                                className="form-select py-3 border-primary"
                                name="owner_name_prefix"
                                value={formData.owner_name_prefix}
                                onChange={handleInputChange}
                                style={{ maxWidth: '120px' }}
                            >
                                <option>Choose...</option>
                                {prefixOfName.map((prefix) => (
                                    <option key={prefix} value={prefix}>{prefix}</option>
                                ))}
                            </select>
                            <input
                                type="text"
                                className="form-control py-3 border-primary"
                                name="owner_name"
                                value={formData.owner_name}
                                onChange={handleInputChange}
                            />
                        </div>
                        {errors.owner_name && <div className="invalid-feedback d-block">Please enter a valid name of owner of clinic.</div>}
                        {errors.owner_name_prefix && <div className="invalid-feedback d-block">{errors.owner_name_prefix}</div>}
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Registration Number (optional)</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="registration_number"
                            value={formData.registration_number}
                            onChange={handleInputChange}
                        />
                        {errors.registration_number && <div className="invalid-feedback d-block">Please enter a valid registration number.</div>}
                    </div>

                    {/* Contact Information */}
                    <div className="col-md-4">
                        <label className="form-label">Contact Number</label>
                        <div className="input-group mb-3">
                            <select 
                                className="form-select py-3 border-primary"
                                name="contact_number_code"
                                value={formData.contact_number_code}
                                onChange={handleInputChange}
                                style={{ maxWidth: '120px' }}
                            >
                                <option>Choose...</option>
                                {countryCodes.map((country) => (
                                    <option key={country.code} value={country.code}>
                                        {country.code}
                                    </option>
                                ))}
                            </select>
                            <input
                                type="tel"
                                className="form-control py-3 border-primary"
                                name="contact_number"
                                value={formData.contact_number}
                                onChange={handleInputChange}
                            />
                        </div>
                        {errors.contact_number_code && <div className="invalid-feedback d-block">Please select phone code.</div>}
                        {errors.contact_number && <div className="invalid-feedback d-block">{errors.contact_number}</div>}
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Email ID</label>
                        <input
                            type="email"
                            className="form-control py-3 border-primary"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                        />
                        {errors.email && <div className="invalid-feedback d-block">Please enter a valid email.</div>}
                    </div>

                    {/* Address Fields */}
                    <div className="col-md-6">
                        <label className="form-label">Address Line 1</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="address_line1"
                            value={formData.address_line1}
                            onChange={handleInputChange}
                        />
                        {errors.address_line1 && <div className="invalid-feedback d-block">Please enter a valid address.</div>}
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Address Line 2 (optional)</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="address_line2"
                            value={formData.address_line2}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">District</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="address_district"
                            value={formData.address_district}
                            onChange={handleInputChange}
                        />
                        {errors.address_district && <div className="invalid-feedback d-block">Please enter a valid district.</div>}
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">State</label>
                        <select
                            className="form-select py-3 border-primary"
                            name="address_state"
                            value={formData.address_state}
                            onChange={handleInputChange}
                        >
                            <option value="">Choose...</option>
                            {indStates.map((val) => (
                                <option key={val.key} value={val.key}>
                                    {val.name}
                                </option>
                            ))}
                        </select>
                        {errors.address_state && <div className="invalid-feedback d-block">Please select a valid state.</div>}
                    </div>
                    {/* <div className="col-md-4">
                        <label className="form-label">Country</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="address_country"
                            value={formData.address_country}
                            onChange={handleInputChange}
                            readOnly 
                        />
                        {errors.address_country && <div className="invalid-feedback d-block">Please enter a valid country.</div>}
                    </div> */}
                    <div className="col-md-4">
                        <label className="form-label">Pincode</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="address_pincode"
                            value={formData.address_pincode}
                            onChange={handleInputChange}
                        />
                        {errors.address_pincode && <div className="invalid-feedback d-block">Please enter a valid pincode (6-digits).</div>}
                    </div>

                    <div className="col-md-12 pt-5">
                        <h4>Bank Details</h4>
                        <hr />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Bank Name</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="bank_name"
                            value={formData.bank_name}
                            onChange={handleInputChange}
                        />
                        {errors.bank_name && <div className="invalid-feedback d-block">{errors.bank_name}</div>}
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Account Number</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="bank_account_number"
                            value={formData.bank_account_number}
                            onChange={handleInputChange}
                        />
                        {errors.bank_account_number && <div className="invalid-feedback d-block">{errors.bank_account_number}</div>}
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">IFSC Code</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="bank_ifsc_code"
                            value={formData.bank_ifsc_code}
                            onChange={handleInputChange}
                        />
                        {errors.bank_ifsc_code && <div className="invalid-feedback d-block">{errors.bank_ifsc_code}</div>}
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">PAN Card Number</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="pan_card_number"
                            value={formData.pan_card_number}
                            onChange={handleInputChange}
                        />
                        {errors.pan_card_number && <div className="invalid-feedback d-block">{errors.pan_card_number}</div>}
                    </div>

                    <div className="col-md-12 pt-5">
                        <h4>Logged-In User Profile Form</h4>
                        <hr />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Name of User</label>
                        <input
                            type="text"
                            className="form-control py-3 border-primary"
                            name="user_name"
                            value={formData.user_name}
                            onChange={handleInputChange}
                        />
                        {errors.user_name && <div className="invalid-feedback d-block">Please enter a valid name of user.</div>}
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">User Phone</label>
                        <div className="input-group mb-3">
                            <select 
                                className="form-select py-3 border-primary"
                                name="user_phone_code"
                                value={formData.user_phone_code}
                                onChange={handleInputChange}
                                style={{ maxWidth: '120px' }}
                            >
                                <option>Choose...</option>
                                {countryCodes.map((country) => (
                                    <option key={country.code} value={country.code}>
                                        {country.code}
                                    </option>
                                ))}
                            </select>
                            <input
                                type="tel"
                                className="form-control py-3 border-primary"
                                name="user_phone_number"
                                value={formData.user_phone_number}
                                onChange={handleInputChange}
                            />
                        </div>
                        {errors.user_phone_code && <div className="invalid-feedback d-block">Please select phone code.</div>}
                        {errors.user_phone_number && <div className="invalid-feedback d-block">{errors.user_phone_number}</div>}
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">User Email ID</label>
                        <input
                            type="email"
                            className="form-control py-3 border-primary"
                            name="user_email"
                            value={formData.user_email}
                            onChange={handleInputChange}
                        />
                        {errors.user_email && <div className="invalid-feedback d-block">Please enter a valid email.</div>}
                    </div>

                </div>

                <div className="mt-4">
                    <button type="submit" className="btn btn-primary" disabled={btnDisabled}>Save Profile</button>
                </div>
            </form>

            <form onSubmit={handlePasswordSubmit} className="needs-validation mt-5">
                <div className="row g-3">
                    <div className="col-md-12">
                        <h4>Update Password</h4>
                        <hr />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Old Password</label>
                        <input
                            type="password"
                            className="form-control py-3 border-primary"
                            name="old_password"
                            value={passwordFormData.old_password}
                            onChange={handlePasswordInputChange}
                            autoComplete="current-password"
                        />
                        {passwordErrors.old_password && <div className="invalid-feedback d-block">{passwordErrors.old_password}</div>}
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">New Password</label>
                        <input
                            type="password"
                            className="form-control py-3 border-primary"
                            name="new_password"
                            value={passwordFormData.new_password}
                            onChange={handlePasswordInputChange}
                            autoComplete="new-password"
                        />
                        {passwordErrors.new_password && <div className="invalid-feedback d-block">{passwordErrors.new_password}</div>}
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Confirm Password</label>
                        <input
                            type="password"
                            className="form-control py-3 border-primary"
                            name="confirm_password"
                            value={passwordFormData.confirm_password}
                            onChange={handlePasswordInputChange}
                            autoComplete="new-password"
                        />
                        {passwordErrors.confirm_password && <div className="invalid-feedback d-block">{passwordErrors.confirm_password}</div>}
                    </div>
                </div>

                <div className="mt-4">
                    <button type="submit" className="btn btn-primary" disabled={passwordBtnDisabled}>Update Password</button>
                </div>
            </form>
        </div>
    );
}
